import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { BcheckTypeEnum } from "../enum/BcheckTypeEnum";
import { generateQueryStringList, generateQueryString } from "src/util/helper";
import { TradeStatusEnum } from "../enum/TradeStatusEnum";
import { TradePhaseEnum } from "../enum/TradePhaseEnum";
import { ITrade } from "../interface/trade/ITrade";
import { IBCheckModal } from '../interface/bcheck/modal-view/IBCheckModal';

enum BCheckServiceEnum {
  realodBackgroundCheck = "/reload-background-check?",
  reloadBCheckByPhaseAndStatus = "/reload-background-check-by-phase-and-status?",
  runBcheckLawyer = "/run-background-check-lawyer",
  getBcheckByTradeId = "/trade/"
}

export class BCheckService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/bcheck");
  }
  public getBcheckByTradeId = async (tradeId: number): Promise<IBCheckModal[]> => await this.GET(BCheckServiceEnum.getBcheckByTradeId + tradeId);

  public updateReLoadBackGroundCheck = async (tradeId: number, bcheckType: BcheckTypeEnum[], changePhase: boolean) => {
    await this.POST(BCheckServiceEnum.realodBackgroundCheck + `${generateQueryStringList(bcheckType, "bcheckType")}&tradeId=${tradeId}&changePhase=${changePhase}`, null);
  };

  public postRunBcheckLawyer = async (trade): Promise<any> => await this.POST(BCheckServiceEnum.runBcheckLawyer, trade);

  public reloadBCheckByPhaseAndStatus = async (status: TradeStatusEnum, phase: TradePhaseEnum, bcheckType: BcheckTypeEnum, changePhase: boolean): Promise<ITrade[]> =>
    await this.PUT(`${BCheckServiceEnum.reloadBCheckByPhaseAndStatus}${generateQueryString({ status, phase, bcheckType, changePhase })}`, null);
}
